module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/client-details/client-details.component.css
// module id = ./src/app/components/client-details/client-details.component.css
// module chunks = main